<template>
  <v-widget :title="$t('Order note')">
    <div
      slot="widget-header-action"
    >
      <v-btn
        v-if="order.id"
        flat
        class="text--secondary text-capitalize"
        @click="setNote"
      >
        {{ $t('Set Note') }}
      </v-btn>

      <v-btn
        v-if="order.id && order.note && order.note === order.$.note"
        flat
        class="error--text text-capitalize"
        @click="removeNote"
      >
        {{ $t('Remove') }}
      </v-btn>

    </div>
    <div slot="widget-content">
      <v-flex>
        <v-form>
          <v-text-field
            v-model="order.note"
            :label="$t('Note')"
            single-line
          />
        </v-form>
      </v-flex>
    </div>
  </v-widget>
</template>

<script>
export default {
  name: 'OrderDraftNote',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  methods: {
    setNote () {
      this.order.addNote(this.order.note)
    },

    removeNote () {
      this.order.deleteNote()
    }
  }
}

</script>
